import Styles from "../../styles/report/reportexercises.module.scss";

const ClientReportExercises = ({ report }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "";
    }

    return date.toLocaleDateString("en-GB", {
      timeZone: "Asia/Dubai",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  // Map a unit to a short label we want to show
  const toUnitLabel = (u) => {
    const unit = String(u || "")
      .trim()
      .toLowerCase();
    switch (unit) {
      case "kg":
      case "kgs":
        return "kg";
      case "cal":
      case "cals":
      case "kcal":
        return "cals";

      default:
        return unit; // fallback to whatever is provided
    }
  };

  // Format a workout item’s absolute score with its unit
  const formatPrimaryScore = (workoutItem) => {
    const val = workoutItem?.scoreAchieved;
    const num = Number(val);
    if (!Number.isFinite(num)) return "";
    // show '-' when score is exactly 0
    if (num === 0) return "-";
    const rounded = Math.round(num);
    const unit = toUnitLabel(workoutItem?.unit || workoutItem?.workout?.unit);
    return unit ? `${rounded} ${unit}` : `${rounded}`;
  };

  const formatUnifiedScore = (workoutItem) => {
    const val = Number(workoutItem?.unifiedMetricScore);
    if (!Number.isFinite(val) || val === 0) return "-";
    return `${Math.round(val)} %`;
  };

  const sortedReports = Array.isArray(report)
    ? [...report].sort(
        (a, b) =>
          (a?.block ?? Number.MAX_SAFE_INTEGER) -
          (b?.block ?? Number.MAX_SAFE_INTEGER)
      )
    : [];

  const reportsByBlock = new Map(
    sortedReports
      .filter((r) => Number.isFinite(r?.block))
      .map((r) => [r.block, r])
  );

  const exerciseData = Array.from({ length: 4 }, (_, i) => {
    const block = i + 1;
    const r = reportsByBlock.get(block);
    const w = (idx) => r?.workouts?.[idx];
    return {
      id: block,
      date: formatDate(r?.workoutReportTestCreatedAt),
      label: w(0)?.scoreAchieved ? "Group Average" : "-",
      backSquat: formatPrimaryScore(w(0)),
      trapBar: formatPrimaryScore(w(1)),
      benchPress: formatPrimaryScore(w(2)),
      pendLay: formatPrimaryScore(w(3)),
      skiErg: formatPrimaryScore(w(4)),
      bikeErg: formatPrimaryScore(w(5)),
      backSquatAvg: formatUnifiedScore(w(0)),
      trapBarAvg: formatUnifiedScore(w(1)),
      benchPressAvg: formatUnifiedScore(w(2)),
      pendLayAvg: formatUnifiedScore(w(3)),
      skiErgAvg: formatUnifiedScore(w(4)),
      bikeErgAvg: formatUnifiedScore(w(5)),
    };
  });

  return (
    <div className={Styles.exercisesReport}>
      <h2 className={Styles.reportTitle}>Exercises Report</h2>
      <div className={Styles.tableContainer}>
        <table className={Styles.exercisesTable}>
          <thead>
            <tr className={Styles.headerRow}>
              <th className={Styles.indexHeader}></th>
              <th className={Styles.dateHeader}></th>
              <th className={Styles.exerciseHeader}>BACK SQUAT</th>
              <th className={Styles.exerciseHeader}>TRAP BAR</th>
              <th className={Styles.exerciseHeader}>BENCH PRESS</th>
              <th className={Styles.exerciseHeader}>PENDLAY</th>
              <th className={Styles.exerciseHeader}>SKI ERG</th>
              <th className={Styles.exerciseHeader}>BIKE ERG</th>
            </tr>
          </thead>
          <tbody>
            {exerciseData.map((row) => (
              <tr key={row.id} className={Styles.dataRow}>
                <td className={Styles.indexCell}>{row?.id || ""}</td>
                <td className={Styles.dateCell}>
                  <div className={Styles.dateValue}>Absolute Score</div>
                  <div className={Styles.labelValue}>TTR Score</div>

                  {/* <div className={Styles.dateValue}>{row?.date || ""}</div>
                  <div className={Styles.labelValue}>{row?.label || ""}</div> */}
                </td>
                <td className={Styles.exerciseCell}>
                  <div className={Styles.primaryValue}>
                    {row?.backSquat || ""}
                  </div>
                  <div className={Styles.secondaryValue}>
                    {row?.backSquatAvg || ""}
                  </div>
                </td>
                <td className={Styles.exerciseCell}>
                  <div className={Styles.primaryValue}>
                    {row?.trapBar || ""}
                  </div>
                  <div className={Styles.secondaryValue}>
                    {row?.trapBarAvg || ""}
                  </div>
                </td>
                <td className={Styles.exerciseCell}>
                  <div className={Styles.primaryValue}>
                    {row?.benchPress || ""}
                  </div>
                  <div className={Styles.secondaryValue}>
                    {row?.benchPressAvg || ""}
                  </div>
                </td>
                <td className={Styles.exerciseCell}>
                  <div className={Styles.primaryValue}>
                    {row?.pendLay || ""}
                  </div>
                  <div className={Styles.secondaryValue}>
                    {row?.pendLayAvg || ""}
                  </div>
                </td>
                <td className={Styles.exerciseCell}>
                  <div className={Styles.primaryValue}>{row?.skiErg || ""}</div>
                  <div className={Styles.secondaryValue}>
                    {row?.skiErgAvg || ""}
                  </div>
                </td>

                <td className={Styles.exerciseCell}>
                  <div className={Styles.primaryValue}>
                    {row?.bikeErg || ""}
                  </div>
                  <div className={Styles.secondaryValue}>
                    {row?.bikeErgAvg || ""}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={Styles.cellpadding}></div>
    </div>
  );
};

export default ClientReportExercises;
